const CancelIcon = props => {
    return (
        <svg
            width='22'
            height='22'
            viewBox='0 0 22 22'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <rect
                y='0.5'
                width='22'
                height='21.3125'
                rx='10.6562'
                fill='white'
                fillOpacity='0.6'
            />
            <path
                d='M7 7.5L15 15.5M7 15.5L15 7.5'
                stroke='black'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    );
};

export default CancelIcon;
